<ng-container *ngIf="loggedUser$ | async as user; else notLogged">
  <div class="user-item">
    <sh-user-logo
      class="rounded-circle mr-2 logo user-avatar"
      [avatarImageType]="user.avatarType"
      [avatarVersion]="user.avatarVersion"
      [fontSize]="'20px'"
      [hasLogo]="user.hasAvatar"
      [id]="user.id"
      [logoTheme]="user.logoTheme"
      [userTitle]="getUserTitle(user)"></sh-user-logo>
    <a [attr.title]="user.text">
      {{ user.text }}
    </a>
  </div>
  <div class="list">
    <a
      [attr.title]="'header.user-menu.settings'"
      (click)="toAdmin(user)">
      {{ 'header.user-menu.settings' | transloco }}
    </a>
    <a
      [attr.title]="'header.user-menu.logout'"
      (click)="logout()">
      {{ 'header.user-menu.logout' | transloco }}
    </a>
  </div>
</ng-container>

<ng-template #notLogged>
  <div
    class="nested-item nested-item-language"
    (click)="openLanguages()">
    <div *ngIf="languageService.current$ | async as language">
      <sh-main-nav-language-flag [code]="language"></sh-main-nav-language-flag>
    </div>
    <ui-icon
      class="chevron"
      key="chevron-right"></ui-icon>
  </div>

  <div
    class="nested-item-content"
    *ngIf="(languagesOpen$ | async) === true">
    <sh-main-nav-languages-mobile
      (closeLanguageBar)="closeLanguages()"
      (closeMenu)="onCloseMenu()"></sh-main-nav-languages-mobile>
  </div>
</ng-template>
